export default "__VITE_ASSET__iAHhx1lo__"